import React, { Component } from 'react';
import { isArrowKeyDown, isEnterKeyDown, toast, getMultiLang } from '@platform/api';
import WithKeyboardChange from '../WithKeyboardChange';
import { getSysFieldid } from '@platform/api';
const { processCursorPointInSide, processCursorPointInTopOrBottom } = WithKeyboardChange;

require('./index.less');

export default class TextArea extends Component {
    constructor(props) {
        super(props);
        this.state = {
            count: (props.value && props.value.length) || 0,
            value: props.value || '',
            json: {},
        };
        this.chineseEntering = false;
    }

    componentWillMount() {
        // 初始化调用getPlatformLang方法获取多语
        let callback = json => {
            this.setState({ json });
        };
        getMultiLang({ moduleId: 'base_text_check', callback }); // moduleId为所需加载json文件夹名称前缀
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.value) {
            let count = (nextProps.value && nextProps.value.length) || 0;
            this.setState({ value: nextProps.value, count });
        }
    }

    /**
     * 组件加载完成
     * @author bbqin
     */
    componentDidMount() {
        let elem = this.refs.rootTextArea;

        let { maxlength, isCheckChinese } = this.props;
        if (elem && maxlength && isCheckChinese) {
            let textAreaNode = ReactDOM.findDOMNode(elem);
            textAreaNode.addEventListener(
                'compositionstart',
                this.setInputFlag.bind(this, textAreaNode, true),
                false,
            );
            textAreaNode.addEventListener(
                'compositionend',
                this.setInputFlag.bind(this, textAreaNode, false),
                false,
            );
        }

        // TODO
        // 标准浏览器
        // elem.focus();
        this.textAreaWrapper.addEventListener('keydown', this.handleTextAreaWrapperKeyDown);
    }

    componentWillUnmount() {
        let { maxlength, isCheckChinese } = this.props;
        if (this.refs.rootTextArea && maxlength && isCheckChinese) {
            let textAreaNode = ReactDOM.findDOMNode(this.refs.rootTextArea);
            textAreaNode.removeEventListener(
                'compositionstart',
                this.setInputFlag.bind(this, textAreaNode, true),
                false,
            );
            textAreaNode.removeEventListener(
                'compositionend',
                this.setInputFlag.bind(this, textAreaNode, false),
                false,
            );
        }

        this.textAreaWrapper.removeEventListener('keydown', this.handleTextAreaWrapperKeyDown);

    }

    setInputFlag = (inputNode, flag, e) => {
        //处理中文输入
        this.chineseEntering = flag;
        if (flag === false) {
            let { maxlength, onChange } = this.props;
            let value = inputNode.value;
            if (value) {
                value = this.getCalcText(value, maxlength);
                e.target.value = value;
            }
            if (typeof onChange === 'function') {
                onChange(value, e);
            }
        }
    }
    //处理中文
    getCalcText = (value, maxlength) => {
        maxlength = Number(maxlength);
        let { json } = this.state;
        // 中文下有个特殊字符 数据库里占用的是两个字符
        let valLength = String(value).replace(/\·|[^\x00-\xff]/gi, "--").length;
        if (typeof maxlength === 'number' && valLength > maxlength) {
            let diffLen = valLength - maxlength;
            let sum = 0;
            let charNum = 0;
            for (let i = value.length - 1; i >= 0; i--) {
                if (/\·|[^\x00-\xff]/.test(value[i])) {
                    sum = sum + 2;
                } else {
                    sum++
                }
                charNum++;
                if (sum >= diffLen) {
                    break;
                }
            }
            value = value.substring(0, value.length - charNum);
            if (json) {
                toast({
                    mark: 'input-maxlength-tip',
                    color: 'danger',
                    title: json['base-maxlength-check-title'],
                    content: json['base-maxlength-check-content1'] +
                        maxlength +
                        '(' +
                        json['base-maxlength-check-content2'] +
                        Math.floor(maxlength / 2) +
                        json['base-maxlength-check-content3'] +
                        ')',
                });
            }

        }
        return value;
    }

    /**
     * focus 如果是tab快捷键操作 选中内容
     * @author  bbqin
     */
    handleFocus = e => {
        let elem = this.refs.rootTextArea,
            index = this.state.value ? this.state.value.length : 0,
            { selfRangControl = true, onFocus } = this.props;
        //这里挖了一个坑  控制的太死了  导致公式编辑器里的文本框  选中状态并不对
        // 加个状态来限制下
        if (elem && elem.setSelectionRange && !this.mouseOperation && selfRangControl) {
            // 标准浏览器
            elem.setSelectionRange(0, index);
        }
        onFocus && onFocus(e);
    };

    handleChange = e => {
        let { maxlength, max, showMax, isCheckChinese } = this.props;
        let value = e.target.value;
        let target = e.target;
        let lens = value.toString().length;
        let maxLen = maxlength || max;
        if (showMax && maxLen && lens > maxLen) {
            value = value.slice(0, maxLen - 1);
        }

        if (isCheckChinese && this.chineseEntering === false && maxlength && value) {
            console.log("其他输入法")
            //其他输入法
            value = this.getCalcText(value, maxlength);
        }

        const { onChange } = this.props;
        this.setState({
            value,
            count: lens,
        }, () => {
            onChange && onChange(value, { target });
        });

    };

    // 網上搜索  Enter 发送，Ctrl+Enter 换行
    insertNewlineToChat = element => {
        let myValue = '\r\n';
        let $t = element || this.refs.rootTextArea;
        console.log(document.selection, $t.selectionStart);
        if (document.selection) {
            $t.focus();
            let sel = document.selection.createRange();
            sel.text = myValue;
            $t.focus();
            sel.moveStart('character', -l);
        } else if ($t.selectionStart || $t.selectionStart == '0') {
            let startPos = $t.selectionStart;
            let endPos = $t.selectionEnd;
            let scrollTop = $t.scrollTop;
            $t.value = $t.value.substring(0, startPos) + myValue + $t.value.substring(endPos, $t.value.length);
            $t.focus();
            $t.selectionStart = startPos + 1;
            $t.selectionEnd = startPos + 1;
            $t.scrollTop = scrollTop;
        } else {
            $t.value += myValue;
            $t.focus();
        }
    };

    handleTextAreaWrapperKeyDown = e => {
        let { onEnter, hotKeyWithArrow, onKeyDown, isFormularEditor = false } = this.props;
        let enterKey = [e.keyCode, e.which, e.charCode].find(e => e === 13) || e.key === 'Enter';
        if (isEnterKeyDown(e)) {
            onEnter && onEnter({ e });
            // 公式编辑器textarea修改为回车键换行
            if (isFormularEditor) {
                this.insertNewlineToChat();
                e.preventDefault();
            }
        }
        // 'ctrl + enter'  'alt + enter' 都可以用
        if (onEnter && enterKey && (!!e.ctrlKey || !!e.altKey) && !isFormularEditor) {
            // console.log(e.ctrlKey, 'ctrl + enter', this.refs.rootTextArea);
            this.insertNewlineToChat();
            // 不能触发keyDown 不然表单有问题
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        let selectionValue = document.getSelection().toString();

        //如果是全选状态就直接切换焦点
        if (isArrowKeyDown(e) && selectionValue === e.target.value) {
            hotKeyWithArrow && hotKeyWithArrow({ e });
        }

        //如果是左右键判断是否是选中了所有文字或判断光标在是否在最左侧||最右侧
        if (isArrowKeyDown(e, [37, 39])) {
            processCursorPointInSide(hotKeyWithArrow, e);
        }

        if (isArrowKeyDown(e, [38, 40])) {
            e.stopPropagation();
            processCursorPointInTopOrBottom(hotKeyWithArrow, e);
        }

        onKeyDown && onKeyDown(e);
    };

    render() {
        let {
            onChange,
            onBlur,
            className,
            showMax = false,
            maxlength,
            showStar,
            max,
            canResize = true,
            rows,
            onEnter,
            fieldid,
            hotKeyWithArrow,
            onKeyDown,
            isCheckChinese = false,
            ...others
        } = this.props;
        fieldid = getSysFieldid(fieldid);
        let { count, value } = this.state;
        let propsValue = value === null ? "" : value;
        max = maxlength || max;
        return (
            <div
                style={{ display: 'inline-block', width: '100%' }}
                className="textarea-hotkey-wrapper textarea-wrap"
                ref={dom => this.textAreaWrapper = dom}
                onMouseDown={e => {
                    // 使用mousedown 来区分tab和鼠标操作的不同
                    this.mouseOperation = true; // by bbqin
                }}
            >
                {showStar ? (
                    <span className="textarea-required-tag">*</span>
                ) : ""}
                <textarea
                    fieldid={fieldid || null}
                    ref="rootTextArea"
                    className={`u-form-control ${className}`}
                    maxLength={!isCheckChinese && max}
                    onChange={this.handleChange}
                    onBlur={e => {
                        onBlur && onBlur(e.target.value);
                        this.mouseOperation = false; // by bbqin
                    }}
                    rows={rows}
                    style={{ resize: canResize ? 'both' : 'none' }}
                    {...others}
                    value={propsValue}
                    onFocus={this.handleFocus}
                />
                {showMax && (
                    <div className="textarea-countClass">
                        <span>{count || 0}</span>
                        <span>/{max}</span>
                    </div>
                )}
            </div>
        );
    }
}
